import axios from "axios"
import {Notification} from "element-ui"

export const $axios = {

  post: async (config, errorMessage = '') => {

    try {

      const request = Object.assign({method: 'post'}, config)

      const response = await axios(request)

      if (![200, 202].includes(response.status)) {
        const notification = response?.message || errorMessage

        if (notification) {
          Notification.error({
            message: notification,
          })
        }
      }

      // return full response
      return response

    } catch (error) {

      // handle errors with responses & messages
      if (error.response) {
        if (error.response.data?.message) {
          // todo: is notification enough?
          Notification.error({
            message: error.response.data.message,
          })
        }

        // handle specific errors in component
        return error.response

      } else {
        // generic error fallback
        Notification.error({
          message: errorMessage || 'Sorry, we encountered an error contacting the server.'
        })
        return false
      }
    }
  }


}
